import { render, staticRenderFns } from "./AddMeal.vue?vue&type=template&id=4c040765"
import script from "./AddMeal.vue?vue&type=script&lang=js"
export * from "./AddMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports